import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { AddressMapProps } from '../Props/AddressMapProps';
import { LAT_LNG_BRUGES } from '../../../Constants/Coördinates';
import { AddressRepo } from '../../../Repo/AddressRepo';
import { Address } from '../Interface/Address';
import { GetAddressFromSuggestion } from '../AddressHelper';

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

const RecenterMap = ({ position }: { position: L.LatLngExpression }) => {
  const map = useMap();
  useEffect(() => {
    map.setView(position, map.getZoom());
  }, [position, map]);
  return null;
};

const AddressMap : React.FC<AddressMapProps> = ({ latitude, longitude, onLocationClicked }) => {
  const [position, setPosition] = useState<L.LatLngExpression>(LAT_LNG_BRUGES as L.LatLngExpression);

  const addressRepo = new AddressRepo();

  useEffect(() => {
    if (latitude != null && longitude != null) {
      setPosition([latitude, longitude] as L.LatLngExpression);
    }
  }, [latitude, longitude]);

  const fetchAddress = async (lat: number, lng: number) => {
    
      const suggestion = await addressRepo.fetchReverseGeocode(lat, lng);
      const addressSuggestion = GetAddressFromSuggestion(suggestion);

      onLocationClicked(addressSuggestion);
  };

  const MapClickHandler = () => {
    useMapEvents({
      click(e) {
        const { lat, lng } = e.latlng;
        setPosition([lat, lng]);
        fetchAddress(lat, lng);
      }
    });
    return null;
  };

  return (
    <div>
      <MapContainer center={position} zoom={12} className='AddressMap-Container'>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapClickHandler />
        <RecenterMap position={position} />
        <Marker position={position} />
      </MapContainer>
    </div>
  );
};

export default AddressMap;
